import { ActionContext } from '@/scripts/store/helpers/createStore';
import { State } from '../state';
import { Getters } from '../getters';
import { Mutations } from '../mutations';
import { Actions } from '../actions';
import { controlAppGateDisplay } from './appGate';
import { obtainVideoSource } from './initiaizeVideoSource';
import { getQueryParams } from '../helpers/helper';
import { checkContentWatchability } from './contentWatchabilityController';
import { filmQuotaLoginFlow } from '@/scripts/pages/video/services/filmQuotaLoginFlowService';
import { VideoOverlayNamedPayload } from '../mutations/manageVideoPlayerOverlays/createOverlayHelper';

export type VideoStoreActionContext = ActionContext<State, Getters, Mutations, Actions, any, any>

const executeAsync = (fn: () => Promise<void>): Promise<void> => fn();

const handleExecuteAsyncError = (context: VideoStoreActionContext) =>
  (error: Error): void => {
    context.commit('setVideoPlayerError', {
      error,
    });
  }
;

export const initializeVideoPage = async(context: VideoStoreActionContext): Promise<void> => {
  const queryParams = getQueryParams();

  obtainVideoSource(context, {
    shouldForceHosted: queryParams.hosted,
  });

  executeAsync(async() => {
    const checkContentWatchabilityPromise = checkContentWatchability(context);
    const filmQuotaLoginFlowInitPromise = filmQuotaLoginFlow.init();

    await checkContentWatchabilityPromise;

    const hasFilmQuotaPresentation = await (async(): Promise<boolean> => {
      if (!context.state.canWatch) return false;

      await filmQuotaLoginFlowInitPromise;

      if (!filmQuotaLoginFlow.service) return false;

      const presentation = await filmQuotaLoginFlow.service.getPresentation();
      if (presentation == null) return false;

      // TODO: Remove as VideoOverlayNamedPayload after upgrading to typescript 4
      context.commit('addVideoPlayerOverlay', presentation as VideoOverlayNamedPayload);
      return true;
    })();

    if (!hasFilmQuotaPresentation) {
      controlAppGateDisplay(context);
    }
  })
    .catch(handleExecuteAsyncError(context))
  ;
};
